import { render, staticRenderFns } from "./projectWeekly.vue?vue&type=template&id=0b4c3408&scoped=true"
import script from "./projectWeekly.vue?vue&type=script&lang=js"
export * from "./projectWeekly.vue?vue&type=script&lang=js"
import style0 from "./projectWeekly.vue?vue&type=style&index=0&id=0b4c3408&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4c3408",
  null
  
)

export default component.exports